import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0662fbfb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "relay-table" }
const _hoisted_3 = { colspan: "5" }
const _hoisted_4 = { class: "relay-style" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "relay-round" }
const _hoisted_7 = { style: {"border-bottom":"1px solid #dddddd"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Team", -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Entry", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Time", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { style: {"line-height":"20px","font-size":"12px","color":"darkgrey"} }
const _hoisted_17 = {
  key: 0,
  colspan: "100%"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { style: {"text-align":"right"} }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_22 = { style: {"line-height":"20px","font-size":"12px","color":"darkgrey"} }
const _hoisted_23 = {
  key: 0,
  colspan: "100%"
}
const _hoisted_24 = {
  key: 1,
  colspan: "100%"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.relayEvents)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relayEvents, (relayEvent) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: relayEvent.eventid
          }, [
            _createElementVNode("table", _hoisted_2, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.get_style_from_event_id(relayEvent.eventid)) + ", " + _toDisplayString(_ctx.get_gender_from_event_id(relayEvent.eventid)), 1),
                    _hoisted_5,
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.get_round_name_from_event_id(relayEvent.eventid)), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_7, [
                  _hoisted_8,
                  (relayEvent.results.length == 0)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_9, "Due"))
                    : (_openBlock(), _createElementBlock("th", _hoisted_10, "Place")),
                  _hoisted_11,
                  _hoisted_12,
                  _hoisted_13
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relayEvent.results, (result) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: result }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_router_link, {
                          to: {
                    name: 'Resultsrelay',
                    params: {
                      meetid: _ctx.$route.params.meetid,
                      eventid: result.eventid,
                      clubid: _ctx.$route.params.clubid,
                      athleteid: 0,
                    },
                  }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Team " + _toDisplayString(result.teamnumber), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", null, [
                        (result.place == -1)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (result.status)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(_ctx.get_dsq_code_from_status(result.status)), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (result.place == 0)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                src: _ctx.get_image_src_from_event_status(3),
                                width: "25",
                                height: "12"
                              }, null, 8, _hoisted_14))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(result.place) + ". ", 1)
                              ], 64)),
                        _hoisted_15
                      ]),
                      _createElementVNode("td", null, _toDisplayString(result.entrytime), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_router_link, {
                          to: {
                    name: 'Resultrelay',
                    params: {
                      meetid: _ctx.$route.params.meetid,
                      clubid: _ctx.$route.params.clubid,
                      eventid: result.eventid,
                      teamnumber: result.teamnumber,
                      athleteid: 0,
                    },
                  }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(result.swimtime), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", null, [
                        (result.isPb)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" 🚀 ")
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tr", _hoisted_16, [
                      (result.athletes)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result.athletes, (athlete) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: athlete.id
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.get_last_name_from_athlete_id(athlete.id)) + ", ", 1)
                              ], 64))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("td", _hoisted_18, "----"))
                    ])
                  ], 64))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relayEvent.entries, (entry) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: entry }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_router_link, {
                          to: {
                    name: 'Heatsrelay',
                    params: {
                      meetid: _ctx.$route.params.meetid,
                      eventid: entry.eventid,
                      clubid: _ctx.$route.params.clubid,
                      athleteid: 0,
                    },
                  }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Team " + _toDisplayString(entry.teamnumber), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.get_weekday_from_event_id(entry.eventid)) + ". " + _toDisplayString(_ctx.get_time_from_event_id(entry.eventid)), 1),
                      _createElementVNode("td", null, _toDisplayString(entry.entrytime), 1),
                      _hoisted_20,
                      _hoisted_21
                    ]),
                    _createElementVNode("tr", _hoisted_22, [
                      (entry.athletes)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_23, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.athletes, (athlete) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: athlete.id
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.get_last_name_from_athlete_id(athlete.id)) + ", ", 1)
                              ], 64))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("td", _hoisted_24, "----"))
                    ])
                  ], 64))
                }), 128))
              ])
            ]),
            _hoisted_25,
            _hoisted_26
          ], 64))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}